import { render, staticRenderFns } from "./YouAuth.vue?vue&type=template&id=c08e30da"
import script from "./YouAuth.vue?vue&type=script&lang=js"
export * from "./YouAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports